<template>
  <div>
    <div
      v-for="layer in mapStyleList"
      :key="layer.id"
      vs-type="flex"
      class="mt-4"
    >
      <layer-item
        :layer="layer"
        :selectedStyleType="selectedStyleType"
        :updateStyleType="updateStyleType"
      />
    </div>
  </div>
</template>

<script>
/**
 * 設定メニュー内で地図の種類一覧を表示するコンポーネント
 * @parent O.Settings
 * @props updateMapStyle: Function マップの種類の更新関数
 * @props displayMapStyle: Number マップの種類のレイヤーID
 */
import LayerItem from "@/components/atoms/LayerItem.vue";
import { LayerMixin } from "@/mixins";

export default {
  name: "M.LayerCard",
  mixins: [LayerMixin],
  components: {
    LayerItem,
  },
  props: {
    /** マップの種類を更新するための関数 */
    updateMapStyle: {
      type: Function,
      required: true,
    },
    /** マップの種類のレイヤーID */
    displayMapStyle: {
      type: Number,
      required: true,
    },
  },
  computed: {
    selectedStyleType() {
      return this.displayMapStyle;
    },
  },
  methods: {
    /** 選択済のレイヤーIDを更新するための関数 */
    async updateStyleType(value) {
      const layer = this.mapStyleList.find((map) => map.id === value);
      await this.updateMapStyle(layer);
    },
  },
};
</script>

<style lang="scss" scoped></style>
